<template>
    <div class="flex-grow-1-scroll h-100 no-gutters provider-content" ref="container">
        <div class='position-relative d-flex flex-column h-100'>

            <!-- <generic-show type='edit'
            event="staff"
            model="user"
            elementname="Staff"
            displayelement="staff-edit"
            route='/api/v1/staff' /> -->

            <generic-edit type='edit'
            event="staff"
            model="user"
            elementname="Staff Member"
            displayelement="staff-edit"
            route='/api/v1/staff'
            :title="$t('translations.profile')"
            ref='genedit' />
        </div>
    </div>
</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
        };
    },
    mounted() {
    // Register event listener

    },
    beforeRouteUpdate (to, from, next) {
            this.checkRouteChange(to, from, next);
    },
    beforeRouteLeave(to, from, next) {
        this.checkRouteChange(to, from, next);
    },
    methods: {
        checkRouteChange(to, from, next) {
            this.checkUnsaved(this.$refs["genedit"].originalData, this.$refs["genedit"].item, to, from, next);
        },
    }
}
</script>
